import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import AddBox from '@material-ui/icons/AddBox';
import SearchIcon from "@mui/icons-material/Search";
import React, {useEffect} from 'react';
import { tableIcons } from '../helpers';
import style from '../components/project/Widgets/Articles/style.module.less';
import StatusBadge from '../components/common/StatusBadge';
import {FactDataActions} from "../components/common/Actions/FactDataActions";
import TooltippedElement from '../components/common/TooltippedElement';
import { styled } from "@mui/material/styles";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import FilterMultiSelect from "../components/table/FilterMultiSelect";
import _ from "lodash";
import {FileView} from "../components/UI/upload/FileInput";

export const styledHeaderSticky = { position: 'sticky', top: 0, zIndex: 10 };

export const styledCellSticky = (offset = null, isLast = false, zIndex = 1, restOptions = {}) => ({
  ...{
    background: 'inherit',
    position: 'sticky',
    left: offset ?? 0,
    zIndex: zIndex,
  },
  ...{
    boxShadow: isLast && 'rgb(0 0 0 / 15%) 5px 0px 5px',
  },
  ...restOptions,
});

/**
 * @param {*} actions
 * @param {*} userCtx
 * @param {?number} stratId
 * @param {?number} portfolioId
 * @param {string} statusType Тип статуса. По сути - тип фактической сущности - request, article, income (deprecated since 2022). Должны еще быть contract и teamMember, но они эту функцию не используют.
 * @param {*} param5
 * @param {?number} policyId
 * @returns
 */
export const getStickyActionAndStatus = (actions, userCtx, stratId, portfolioId, statusType, {lookup,filterComponent} = {}, policyId = null) => [
  {
    title: 'Действ.',
    sorting: false,
    render: (rowData) => (
      <FactDataActions
        props={{ ...rowData, entityType: statusType }}
        actions={actions}
        userCtx={userCtx}
        stratId={stratId}
        portfId={portfolioId}
        policyId={policyId}
      />
    ),
    width: ActionColumnProperties.width,
    cellStyle: styledCellSticky(),
    headerStyle: styledCellSticky(),
    filterCellStyle: styledCellSticky(null, false, 10),
  },
  {
    title: 'Статус',
    field: 'status',
    filtering: !!filterComponent ?? false,
    sorting: false,
    lookup:!!filterComponent && lookup,
    headerStyle: styledCellSticky(ActionColumnProperties.offset, true),
    cellStyle: !filterComponent && styledCellSticky(ActionColumnProperties.offset, true),
    filterCellStyle: filterComponent ? filterComponent : styledCellSticky(ActionColumnProperties.offset, true, 10),
    render: ({ status, comment }) => (comment
      ? <TooltippedElement tooltip={comment}><StatusBadge type={statusType} status={status} /></TooltippedElement>
      : <StatusBadge type={statusType} status={status} />),
    minWidth: '170px',
  },
]

export const getStickyColumns = (elements,actionWidth=40) => {

  const cols = []
  let prevWidth = parseInt(actionWidth.toString().match(/\d+/))
  elements?.forEach((element, index)=>{
    const isLastCol = index+1 === elements.length
    cols.push({
      ...element,
      editable:element?.editable ?? false,
      title:element.title,
      field:element.field,
      filtering: element?.filtering ?? element?.filterCellStyle ?? element?.filterComponent ?? false,
      sorting: element?.sorting ?? false,
      headerStyle: styledCellSticky(prevWidth,isLastCol,16,{background:'#fff'}),
      cellStyle: styledCellSticky(prevWidth,isLastCol,8,),
      filterCellStyle: styledCellSticky(prevWidth,isLastCol,9,{background:'#fff', ...element.filterCellStyle}),
      // width: element?.width,
      hidden:element?.hidden ?? false,
      lookup:element.lookup ?? null,
      minWidth: element?.width,
      render: element.render,
      filterComponent: element.filterComponent,
      removable: element.removable?? false,
      customFilterAndSearch: element.customFilterAndSearch
    })
    prevWidth = prevWidth + parseInt(element?.width?.toString().match(/\d+/))
  })
  return cols
}

export const ActionColumnProperties = {
  width: 60,
  offset: 63,
};

export const localization = {
  pagination: {
    labelDisplayedRows: '{from}-{to} из {count}',
    labelRowsSelect: 'Строк',
    firstTooltip: '1 Страница',
    previousTooltip: 'Предыдущая Страница',
    nextTooltip: 'Следующая Страница',
    lastTooltip: 'Последняя Страница',
  },
  body: {
    emptyDataSourceMessage: 'Ничего не найдено',
    filterRow: {
      filterTooltip: 'Поиск по столбцу',
    },
    addTooltip: 'Добавить строку',
    editTooltip: 'Редактировать',
    deleteTooltip: 'Удалить',
    editRow: {
      deleteText: <div className="row-delete-prompt">Вы уверены, что хотите удалить эту строку?</div>,
      saveTooltip: 'Ок',
      cancelTooltip: 'Отмена',
    },
  },
  header: {
    actions: 'Действ.',
  },
  toolbar: {
    searchTooltip: 'Поиск',
    searchPlaceholder: 'Поиск',
    addRemoveColumns:"Добавить или скрыть столбцы",
    showColumnsTitle:'Показать столбцы',
    showColumnsAriaLabel:'Показать столбцы'
  },
};

export const LocalizationWithSmallActions = {
  ...localization,
  header: {
    actions: 'Действ.',
  },
};

export const options = {
  pageSize: 10,
  pageSizeOptions: [10, 30, 50],
  headerStyle: {
    fontSize: 12,
    lineHeight: 1.3,
    padding: '8px 16px',
  },
  filterCellStyle: {
    padding: '8px 16px',
  },
  draggable:false,
  filtering: true,
  sorting: true,
  search: false,
  paging: false,
};

export const tableIconsModified = {
  ...tableIcons,
  ...{
    Edit: ({ disabled }) => (
      <Edit
        style={{ color: !disabled ? '#ffc107' : undefined }}
        color={disabled ? 'disabled' : undefined}
      />
    ),
    Delete: ({ disabled }) => <Delete style={{ color: !disabled ? '#dc3545' : undefined }} />,
    Add: () => <AddBox style={{ color: '#0d6efd' }} />,
  },
};

export const modifyDefaultOptions = (newOptions) => ({
  ...options,
  ...newOptions,
  headerStyle: { ...options.headerStyle, ...(newOptions.headerStyle || {}) },
  filterCellStyle: { ...options.filterCellStyle, ...(newOptions.filterCellStyle || {}) },
});

export const modifyDefaultLocalization = (newLocalization) => ({
  ...localization,
  ...newLocalization,
  header: { ...localization.header, ...(newLocalization.header || {}) },
});

export const getCustomFilterAndSearch = (query, value) => value.toLowerCase().indexOf(query.toLowerCase()) > -1;

export const objectToCols = (objectCols) => {
  const getBaseCols = (titleCol, fieldCol, optionsRest) => {
    const { title, field, ...optionsCols } = { titleCol, fieldCol, ...optionsRest };
    return {
      ...{
        title,
        field,
        filtering: optionsCols?.filtering ?? false,
        sorting: optionsCols?.sorting ?? false,
        render: (rowData) => (rowData[field] ? rowData[field] : <div className={style.noData}>—</div>),
        width: optionsCols?.width ?? '250px',
        minWidth: optionsCols?.minWidth || optionsCols?.width || '150px',
        filterCellStyle: optionsCols?.filterCellStyle ?? {},
        headerStyle: optionsCols.headerStyle ?? { textAlign: 'left' },
        cellStyle: optionsCols.cellStyle ?? { textAlign: 'left' },

      },
      ...optionsCols,
    };
  };

  return [...objectCols.map((x) => getBaseCols(x.title, x.field, {
    ...{
      filtering: true,
      sorting: true,
      filterCellStyle: { minWidth: '70px', width: '12%' },

    },
    ...x,
  }))];
};

export const addColumnsWithFullNameInData = (data, addColumnsArray) => {
  data.forEach((x) => {
    addColumnsArray.forEach((y) => {
      x[y?.columnName] = Array.isArray(x[y?.propertyName]) ? x[y?.propertyName].map((x) => `${x?.lastName} ${x?.firstName} ${x?.middleName ?? ''}`).join('\n') : null;
    });
  });
  return data;
};

export function FilterInput({ columnDef, onFilterChanged, MTableFiltersRef, field }) {
  useEffect(() => {
    if(Boolean(columnDef?.tableData?.id && onFilterChanged && MTableFiltersRef?.current?.[field]))
      try{
        onFilterChanged(columnDef?.tableData?.id, MTableFiltersRef?.current?.[field]);
      }
      catch(error){
      }
  }, []);

  return (
    <MTableFilterInput
      field={field}
      value={MTableFiltersRef?.current?.[field]}
      onChange={(e) => {
        MTableFiltersRef.current[field] = e.target.value;
        onFilterChanged(columnDef?.tableData?.id, e.target.value);
      }}
    />
  );
}

export function MTableFilterInput(props) {
  const ValidationTextField = styled(TextField)({
    "& label.Mui-focused": {
      color: "#3f51b3",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#3f51b3",
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#3f51b3",
      },
    },
  });

  return (
    <TextField
      {...props}
      autoComplete="off"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ fontSize: "16px", color: "black" }} style={{fontSize:"16px"}} />
          </InputAdornment>
        ),
      }}
      variant="standard"
    />
  );
}

export const arrayToLookup = (key, values,valueKeyProperty='') => {
  if (!values) return {};
  const filteredValues = values.filter((e) => e[key])
  if (filteredValues.length === 0) return false
  const splittedProps = valueKeyProperty.split('.')
  const uu = _.uniqWith(filteredValues
      .sort((a, b) => {
        return a[key] === b[key] ? 0 : a[key] < b[key] ? -1 : 1;
      })
      .map((v) => {
        const b = splittedProps.reduce((accum,curr,index) => accum[curr],v)
        return [b ?? v[key], v[key]]
      }),_.isEqual)
  return valueKeyProperty.length ? uu : Object.fromEntries(uu)
};

export const arrayToLookupWithEmpty = (key, values,valueKeyProperty='') => {
  if (!values) return {};
  const filteredValues = values.filter((e) => e[key])
  if (filteredValues.length === 0) return false
  const splittedProps = valueKeyProperty.split('.')
  let uu = _.uniqWith(filteredValues
      .sort((a, b) => {
        return a[key] === b[key] ? 0 : a[key] < b[key] ? -1 : 1;
      })
      .map((v) => {
        const b = splittedProps.reduce((accum,curr,index) => accum[curr],v)
        return [b ?? v[key], v[key]]
      }),_.isEqual)
  uu.unshift(['', 'Не указано'])
  return valueKeyProperty.length ? uu : Object.fromEntries(uu)
};

export const arrayToLookupSortAlph = (values, valueField, titleField) => {
  return values && values.length > 0
      ? Object.fromEntries(
          values
              .sort((a, b) => {
                return a.displayName === b.displayName ? 0 : a.displayName < b.displayName ? -1 : 1;
              })
              .map(v => [v[valueField], v[titleField || valueField]])
      )
      : {};
}

export const formatDate = (date) => {
  if (date){
    date = date.split('T')[0].split('-')
    date.reverse()
    date = date.join('.')
  }
  return date
}

export const mapFilesForModal = (files,title) => {
  return (
      <div className={'mt-lg-2'}>
        <h3 style={{fontWeight:600}}>{title}</h3>
        <div className={'mt-lg-4'}>
          {!!files.length ? files.map((x,y)=><FileView disabled={true} isDownloadable={true} item={x} index={y} />): <span className={style.noFiles}>—</span>}
        </div>
      </div>
  )
}

export const getResultImpactLabel = (stratResultId, resultsImpact = []) => {
  const item = resultsImpact.find(result => result.id === stratResultId);
  if(item){
    let num = item.num;
    if(item.parentId){
      const parent = resultsImpact.find(result => result.id === item.parentId);
      num = `${parent.num}.${item.num}`;
    }
    else{
      num += '.'
    }
    return `${num} ${item.name}`;
  }
  return '-'
}

export const getOptionsByField = (sourceArray, fieldName) => sourceArray
  .filter(value => !!value[fieldName])
  .reduce((acc, curr) => {
  return acc.some(value => value.label === curr[fieldName]) ? acc : [...acc, {label: curr[fieldName], value: curr[fieldName]}]
}, [])

export function sortByAlphaNum(a, b) {
  if (!a || !b) return 0;
  
  const regex = /^([А-ЯЁа-яё]+)(\d*)$/;
  const matchA = a.match(regex) || [];
  const matchB = b.match(regex) || [];
  
  const prefixA = matchA[1] || '';
  const prefixB = matchB[1] || '';
  const numA = parseInt(matchA[2] || '0', 10);
  const numB = parseInt(matchB[2] || '0', 10);

  if (numA === 0 && numB !== 0) return 1;
  if (numB === 0 && numA !== 0) return -1;

  const prefixCompare = prefixA.localeCompare(prefixB, 'ru');
  if (prefixCompare !== 0) {
    return prefixCompare;
  }

  return numA - numB;
}

export function sortMilestonesByFactDateDesc(a, b) {
  if (!a.yearFact || !a.monthFact) return 1;
  if (!b.yearFact || !b.monthFact) return -1;
  if (a.yearFact !== b.yearFact) return b.yearFact - a.yearFact;
  return b.monthFact - a.monthFact;
}
